'use client';

import { useState } from 'react';
import Icon from '@/components/ui/AppIcon';

interface FAQItem {
  id: string;
  question: string;
  answer: string;
}

export default function TechnicalSupportSection() {
  const [openId, setOpenId] = useState<string | null>(null);

  const faqs: FAQItem[] = [
    {
      id: 'tech_1',
      question: 'Where can I find feeding guidelines?',
      answer: 'Detailed feeding guidelines are provided with every purchase of Bloom concentrates. You can also contact our technical support team at 0777 014 115 or 0704 846 600 for personalized feeding recommendations based on your flock size, bird age, and production goals.'
    },
    {
      id: 'tech_2',
      question: 'What if I experience issues with my flock?',
      answer: 'If you experience any issues with your flock after using Bloom concentrates, contact our technical support team immediately. We will help troubleshoot the issue, which may involve reviewing your feeding program, water quality, housing conditions, and bird health. Our team is committed to ensuring your success.'
    },
    {
      id: 'tech_3',
      question: 'Do you offer farm visits?',
      answer: 'Yes, we offer farm visits for our customers. Our technical team can visit your farm to assess your feeding program, provide on-site training, and offer recommendations for optimizing productivity. Farm visits can be arranged by contacting our technical support team.'
    },
    {
      id: 'tech_4',
      question: 'Is training available for farmers?',
      answer: 'Yes, we provide training for farmers on proper feed mixing, poultry nutrition basics, flock management, and maximizing the benefits of Bloom concentrates. Training can be arranged individually or in groups. Contact us to schedule a training session for your farm or cooperative.'
    },
    {
      id: 'tech_5',
      question: 'How do I contact the technical team?',
      answer: 'You can reach our technical support team by calling 0777 014 115 or 0704 846 600, emailing info@bloomanimalfeeds.com, or filling out the inquiry form on our Contact page. Our team is available Monday to Saturday, 8:00 AM to 5:00 PM to assist with all your technical questions.'
    }
  ];

  const toggleFAQ = (id: string) => {
    setOpenId(openId === id ? null : id);
  };

  return (
    <section className="py-section-sm px-6">
      <div className="max-w-4xl mx-auto">
        <div className="mb-12">
          <h2 className="text-heading-3 text-foreground mb-4">Technical Support</h2>
          <p className="text-muted-foreground">
            Get help with feeding guidelines, troubleshooting, farm visits, and training for farmers.
          </p>
        </div>

        <div className="space-y-4">
          {faqs?.map((faq) => (
            <div
              key={faq?.id}
              className="bg-white rounded-lg border border-border overflow-hidden transition-all hover:shadow-md"
            >
              <button
                onClick={() => toggleFAQ(faq?.id)}
                className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-secondary/5 transition-colors"
              >
                <span className="font-semibold text-foreground pr-4">{faq?.question}</span>
                <Icon
                  name={openId === faq?.id ? 'ChevronUpIcon' : 'ChevronDownIcon'}
                  size={20}
                  className="text-primary flex-shrink-0"
                />
              </button>
              {openId === faq?.id && (
                <div className="px-6 pb-5 text-muted-foreground leading-relaxed">
                  {faq?.answer}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}